import { render, staticRenderFns } from "./SPDocSync.vue?vue&type=template&id=17f88f2c"
import script from "./SPDocSync.vue?vue&type=script&lang=ts"
export * from "./SPDocSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f88f2c')) {
      api.createRecord('17f88f2c', component.options)
    } else {
      api.reload('17f88f2c', component.options)
    }
    module.hot.accept("./SPDocSync.vue?vue&type=template&id=17f88f2c", function () {
      api.rerender('17f88f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SPDocSync.vue"
export default component.exports